import React from "react";
import { StyledTitlesTyp } from "./StyledTitlesTyp.styled";
import { SyledFontWeight } from "./SyledFontWeight.styled";
import { FontWeightEnum } from "../../types/AppTypes";
import { StyledBodyTyp } from "./StyledBodyTyp.styled";
import { StyledCaptionsTyp } from "./StyledCaptionsTyp.styled";

type TypographyProps = {
  fontWeight?: FontWeightEnum;
  variant?: string;
  children: React.ReactNode;
  color?: string;
  noTranslate?: boolean;
  noLineHeight?: boolean;
  maxWidth?: number;
};

export const TitlesTyp = ({
  fontWeight,
  variant,
  children,
  color,
  noTranslate,
}: TypographyProps) => {
  return (
    <SyledFontWeight $fontWeight={fontWeight}>
      <StyledTitlesTyp
        $variant={variant}
        $color={color}
        {...(noTranslate && { translate: "no" })}
      >
        {children}
      </StyledTitlesTyp>
    </SyledFontWeight>
  );
};
export const BodyTyp = ({
  fontWeight,
  variant,
  children,
  color,
  noTranslate,
  noLineHeight = false,
  maxWidth,
}: TypographyProps) => {
  return (
    <SyledFontWeight $fontWeight={fontWeight}>
      <StyledBodyTyp
        $noLineHeight={noLineHeight}
        $variant={variant}
        $color={color}
        {...(noTranslate && { translate: "no" })}
        $maxWidth={maxWidth}
      >
        {children}
      </StyledBodyTyp>
    </SyledFontWeight>
  );
};
export const CaptionsTyp = ({
  fontWeight,
  variant,
  children,
  color,
  noTranslate,
}: TypographyProps) => {
  return (
    <SyledFontWeight $fontWeight={fontWeight}>
      <StyledCaptionsTyp
        $variant={variant}
        $color={color}
        {...(noTranslate && { translate: "no" })}
      >
        {children}
      </StyledCaptionsTyp>
    </SyledFontWeight>
  );
};
